import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import {useDispatch} from "react-redux"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Formik, Form } from "formik"
import { RequestPasswordChangeSchema } from "../../utils/yupValidators"
import { sendRequestPasswordChange } from "../../actions/Utils/app"
import InputLabel from "@mui/material/InputLabel"
import Input from "@mui/material/Input"
import FormControl from "@mui/material/FormControl"

const useStyles = makeStyles({
    card: {
        background: "#fff",
        border: "1px solid #DBDBDB",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgba(0,0,0,.04)",
        borderRadius: 8,
        width: 364,
        "& .MuiCardContent-root": {
            padding: "32px 32px 0",
        },
        "& .MuiCardActions-root": {
            padding: "24px 32px 32px",
            justifyContent: "center",
        },
        "& .MuiButton-containedPrimary": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
        },
        "& .MuiButton-containedPrimary:hover": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
            filter: "brightness(.93)",
        },
    },
    title: {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: "28px",
        color: "#555555",
        marginBottom: 24,
    },
    textField: {
        marginTop: 20,
        width: "100%",
        fontSize: 16,
        "& .MuiInputLabel-root": { color: "#555555" },
        "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": { color: "#555555" },
        "& .MuiInput-underline:before": { borderBottomColor: "#DBDBDB" },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "#BDBDBD",
            borderBottomWidth: 1,
        },
        "& .MuiInput-underline:after": { borderBottomWidth: 1 },
    },
    errorField: {
        color: "#F44259",
        marginTop: 7,
        fontSize: 13,
        lineHeight: "18px",
    }
})

const RequestPasswordChange = (props) => {
    const {
        location
    } = props

    const classes = useStyles()
    const dispatch = useDispatch()

    const _sendRequestPasswordChange = values => {
        dispatch(sendRequestPasswordChange(values.email, location.state && location.state.returnPath))
    }

    return (
        <div className="flexCenter height100">
            <Formik
                enableReinitialize
                initialValues={{
                    email: ""
                }}
                onSubmit={_sendRequestPasswordChange}
                validationSchema={RequestPasswordChangeSchema}
            >
                {({
                    values,
                    errors,
                    handleChange
                }) => {
                    return (
                        <Form>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.title}>
                                        Réinitialiser votre mot de passe
                                    </Typography>
                                    <FormControl className={classes.textField} variant="standard" error={!!errors.email}>
                                        <InputLabel>Email</InputLabel>
                                        <Input
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className={classes.errorField}>{errors.email}</div>
                                        )}
                                    </FormControl>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        color="primary"
                                        type="submit"
                                        variant="contained"
                                    >
                                        RÉINITIALISER LE MOT DE PASSE
                                    </Button>
                                </CardActions>
                            </Card>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default RequestPasswordChange
